import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
//import { remoteConfig } from "../../../../../config/config";
import { Link } from "react-router";
import { Loader } from '../../common/elements';
import { NetworkHelpers as Network } from '../../../helpers';

import commonActions from '../../../actions/common/common';

class Slot extends Component {

    componentDidMount() {

        const { slotId, getSlotData } = this.props;

        const sponsorshipType = Network.getSponsorshipType( window.innerWidth );

        getSlotData( slotId, null, false, false, sponsorshipType );

    }

    clickedAdvert = ( advertId, url ) => {

        const { clickedAdvert } = this.props;

        clickedAdvert( advertId );

        const win = window.open( url, '_blank');
        win.focus();
    };

    render() {

        const { slotId, slotData } = this.props;

        if( slotData.length === 0 ) {
            return <Loader />;
        }
        
        const presentSlot = slotData.filter( slot => parseInt( slot.slot_id, 10 ) === parseInt( slotId, 10 ) )[0];
        
        if( !presentSlot ) {
            return <Loader />;
        }

        let link;

        if ( presentSlot.slot_id === 2 ) link = `/training/interactive-webinars`;
        if ( presentSlot.slot_id === 3 ) link = `/training/courses`;
        if ( presentSlot.slot_id === 4 ) link = `/training/podcasts`;
        if ( presentSlot.slot_id === 5 ) link = `/media`;
        if ( presentSlot.slot_id === 6 ) link = `/members`;
        if ( presentSlot.slot_id === 7 ) link = `/forums`;

        if( !presentSlot ){
            return <Loader />
        }

        if (presentSlot.content) {
            return (
                <Link to={ link }>
                    <div dangerouslySetInnerHTML={ {__html: presentSlot.content } }/>
                </Link>
            );
        } else {

            const advertId = presentSlot.id;

            return (
                <div>
                    <button onClick={ () => this.clickedAdvert( advertId, presentSlot.url ) }>
                        <img src={ presentSlot.image }/>
                    </button>
                </div>
            );
        }
    }
}

Slot.propTypes = {
    slotId: PropTypes.number.isRequired,
    network: PropTypes.string.isRequired,
};

const mapStateToProps = ( state ) => {
    return {
        slotData: state.common.slotData,
    };
};

const mapDispatchToProps = ( dispatch ) => {
    return {
        getSlotData: ( slotId, slider, addToSliderData, sponsorshipType ) => dispatch( commonActions.getSlotData( slotId, slider, addToSliderData, sponsorshipType ) ),
        clickedAdvert: ( advertId ) => dispatch( commonActions.clickedAdvert( advertId ) ),
    };
};

export default connect( mapStateToProps, mapDispatchToProps )( Slot );


// WEBPACK FOOTER //
// src/client/components/common/elements/Slot.js